import React, { FC } from 'react';
import styled from '@emotion/styled';
import {
    BodyTextMedium,
    Button,
    HeadingText40,
    Modal,
    pxToRem,
} from '@modernhealth/vital-components';
import { colors } from '@modernhealth/vital-foundation';
import { useTranslation } from 'react-i18next';

export interface ConfirmModalProps {
    title: string;
    description: string;
    confirmLabel: string;
    onConfirm: VoidFunction;
    onCancel: VoidFunction;
    isVisible?: boolean;
    type?: 'change' | 'remove';
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
    title,
    description,
    confirmLabel,
    onConfirm,
    onCancel,
    isVisible = false,
    type = 'change',
}) => {
    const { t } = useTranslation();
    const ConfirmButton = type === 'remove' ? RedButton : Button;
    return (
        <Modal isVisible={isVisible} maxWidth={450} noPaddings>
            <Container>
                <HeadingText40 marginBottom={18} centered>
                    {title}
                </HeadingText40>
                <BodyTextMedium marginBottom={30} centered>
                    {description}
                </BodyTextMedium>
                <ConfirmButton onClick={onConfirm} variant="primary" fluid>
                    {confirmLabel}
                </ConfirmButton>
                <CancelButton onClick={onCancel} variant="flat" fluid>
                    {t('common.not_now')}
                </CancelButton>
            </Container>
        </Modal>
    );
};

const Container = styled.div({
    padding: pxToRem(40, 30, 24, 30),
});

const RedButton = styled(Button)({
    backgroundColor: colors.red55,
    borderColor: colors.red55,

    '&&&&&:hover': {
        backgroundColor: colors.red30,
        borderColor: colors.red30,
    },
});

const CancelButton = styled(Button)({
    marginTop: pxToRem(16),
});
